
import "./drustvene.css";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Link } from 'react-router-dom';
import fico from './fico-logo.svg';



const Drustvene = () => {
  return (
    <div className="social-links mb-2">
      <a
        href="https://www.instagram.com/mrle_garage/reels/?__d=1%2F"
        target="_blank"
        rel="noreferrer"
        className="social-icon instagram"
      >
        <i className="fab fa-instagram"></i>
      </a>

      <a
        href="https://geteventlyapp.com/event/60aec1ff-c0fe-4dc3-afce-3c9f46231d2c"
        target="_blank"
        rel="noreferrer"
        className="social-icon facebook"
      >
        <i class="fa-duotone fa-solid fa-e"></i>
      </a>

      <a
        href="https://www.instagram.com/auto_fico_shop/"
        target="_blank"
        rel="noreferrer"
        className="social-icon x"
      >
        <Link className="majice" to="https://www.instagram.com/auto_fico_shop/">
              <img src={fico} className="logo" alt="logo" height="45" />
          </Link>      
        </a>
    </div>
  );
};

export default Drustvene;